import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';

const mobileNavbarOffset = `calc(40px + ${spacing.space8} + ${spacing.space8} + ${spacing.space12})`;
const mobileMenuHeight = `calc(100vh - ${mobileNavbarOffset})`;
const mobileMenuDynamicHeight = `calc(100dvh - ${mobileNavbarOffset})`;

export const Wrapper = styled.nav<{
  $isMenuOpen?: boolean;
}>`
  display: none;

  @media (max-width: ${breakpoints.l}) {
    display: block;
    background-color: ${nafColor.signature.yellow10};
    border: 1px solid ${nafColor.signature.yellow20};
    border-top: 0;
    border-radius: 0 0 ${spacing.space8} ${spacing.space8};
    box-sizing: border-box;
    padding: ${spacing.space16} ${spacing.space24} ${spacing.space64} ${spacing.space24};
    position: sticky;
    overflow-y: auto;
    height: ${mobileMenuHeight};
    max-height: ${mobileMenuHeight};
    overscroll-behavior: contain;
    z-index: 100;

    @supports (height: 100dvh) {
      height: ${mobileMenuDynamicHeight};
      max-height: ${mobileMenuDynamicHeight};
    }

    ${({ $isMenuOpen }) =>
      $isMenuOpen === false &&
      css`
        position: absolute !important;
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
        height: 0 !important;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
      `}

    ${({ $isMenuOpen }) =>
      $isMenuOpen === true &&
      css`
        opacity: 1;
        pointer-events: auto;
        visibility: visible;
      `}
  }
`;

export const Content = styled.div<{ $isSystemMessageActive?: boolean }>`
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ $isSystemMessageActive }) => ($isSystemMessageActive ? '300px' : spacing.space120)};
`;

export const HighlightedLinks = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.space24} 0;
  background-color: ${nafColor.signature.white};
  padding: ${spacing.space16};
  gap: ${spacing.space12};
`;

export const RoadsideAssistanceButtonWrapper = styled.div`
  /* Navbar resets box-sizing to content-box for all descendants, breaking the button's width="full". */
  > a {
    box-sizing: border-box !important;
  }
`;
